
import { Options, Vue } from 'vue-class-component';

import NavBar from './components/NavBar.vue';
import HomePage from './pages/HomePage.vue';
import FootPage from './pages/FootPage.vue';

@Options({
  components: {
    NavBar,
    HomePage,
    FootPage
  },
})
export default class App extends Vue {}
